import {SimpleSpanProcessor, WebTracerProvider} from '@opentelemetry/sdk-trace-web';
import {Resource} from '@opentelemetry/resources';
import {SemanticResourceAttributes} from '@opentelemetry/semantic-conventions';
import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {registerInstrumentations} from '@opentelemetry/instrumentation';
import {DocumentLoadInstrumentation} from '@opentelemetry/instrumentation-document-load';
import {FetchInstrumentation} from '@opentelemetry/instrumentation-fetch';
import {trace} from '@opentelemetry/api';

const env = (window as any).ENV || {};
const serviceName = env.OTEL_SERVICE_NAME || 'aegis-frontend';
const otelEndpoint = env.OTEL_EXPORTER_OTLP_ENDPOINT || 'http://localhost:4318/v1/traces';
const otelEnabled = env.OTEL_ENABLED === 'true';

export const tracer = otelEnabled ? initializeTracer() : null;

function initializeTracer() {
  console.log('Initializing OpenTelemetry...');

  const resource = new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: serviceName,
    [SemanticResourceAttributes.SERVICE_VERSION]: '1.0.0',
    [SemanticResourceAttributes.DEPLOYMENT_ENVIRONMENT]: process.env.NODE_ENV || 'development',
  });

  const provider = new WebTracerProvider({
    resource: resource,
  });

  const exporter = new OTLPTraceExporter({
    url: otelEndpoint,
  });

  provider.addSpanProcessor(new SimpleSpanProcessor(exporter));
  provider.register();

  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      new FetchInstrumentation({
        ignoreUrls: [/localhost:8090\/sockjs-node/],
        propagateTraceHeaderCorsUrls: [/.+/g],
      }),
    ],
  });

  return trace.getTracer('aegis-frontend-tracer');
}

export function createSpan(name: string, fn: () => Promise<any>) {
  if (!otelEnabled || !tracer) {
    return fn();
  }

  return tracer.startActiveSpan(name, async (span) => {
    try {
      const result = await fn();
      span.end();
      return result;
    } catch (error) {
      span.recordException(error as Error);
      span.setStatus({ code: 2 });
      span.end();
      throw error;
    }
  });
}

export function initializeOpenTelemetry() {
  if (otelEnabled) {
    console.log(`OpenTelemetry initialized with service name: ${serviceName}`);
    console.log(`OpenTelemetry exporter endpoint: ${otelEndpoint}`);
    return true;
  }
  console.log('OpenTelemetry is disabled');
  return false;
}
